export default __webpack_public_path__ + "static/media/P_sound.509eef76.mp3";